export default __webpack_public_path__ + "static/media/rockmelon.cc26d6ce.webp";